import { useObjectVal } from 'react-firebase-hooks/database'
import { Reference, Query } from '@allcoinwallet/inkryptus-db-schema'

export * from '@allcoinwallet/inkryptus-db-schema'

export function useDatabaseObject<T>(ref: Reference<T> | Query<T> | null | undefined) {
  return useObjectVal<T>(ref as any)
}
